import activityFactory from '@polleverywhere/core/lib/activity_factory'
import ParticipantDiscourse from './participant/discourse'
import PresenterDiscourse from './presenter/discourse'

/**
 * Get the correct activity model
 *
 * Allows for using GraphQL where appropriate
 *
 * @param {Object} data
 * @param {string} data.type Activity type
 * @param {string} [data.participant_key] The participant key
 * @param {string} [data.presenter_key] The presenter key
 * @param {string} [data.shared_key] The shared key
 * @param {string} [data.permalink] DEPRECATED use shared_key
 * @param {Object} [options]
 * @param {boolean} [options.legacy=false] DEPRECATED use unstable instead, as some graphql models are stable now
 * @param {boolean} [options.unstable=false] Set true to use unstable graphql backed models
 * @return {Backbone.Model | undefined} May resolve undefined if data doesn't resolve to a Model
 */
export default function (data, options = {}) {
  if (data.type === 'discourse' && (data.presenter_key || data.shared_key || data.permalink)) {
    return new PresenterDiscourse(data)
  }

  if (data.type === 'discourse' && data.participant_key && !data.presenter_key) {
    return new ParticipantDiscourse(data)
  }

  return activityFactory(data, options)
}
